import React from 'react';
import i18next from 'i18next';

import styles from '../../styles.module.scss';

import { checkoutAnswerTypes } from './types';

function CheckoutAnswers({ checkoutAnswers }) {
  const questionWithAnswers = checkoutAnswers.filter((question) => question.answer);

  return (
    <>
      {questionWithAnswers.length > 0 && (
        <div className="row">
          <div className={styles.clientTitle}>
            <span className="bold font-size-14">{i18next.t('OrdersDetails:checkoutQuestions')}</span>
          </div>
          <div>
            {questionWithAnswers.map((question) => (
              <div key={question.checkoutQuestionId} className={styles.question}>
                {question.checkoutQuestion} <span className="bold">—{question.answer}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}

CheckoutAnswers.propTypes = checkoutAnswerTypes;

export default CheckoutAnswers;
